module.exports = __webpack_public_path__ + "img/outbox.53c290e6.svg";